<template>
    <Card :dis-hover="true">
        <Tabs v-model="userType"
            :animated="false"
            :capture-focus="true">
            <TabPane label="管理员" name="admin">
                <AdminUserList v-if="userType === 'admin'" />
            </TabPane>
            <!-- <TabPane label="专家"
                name="master">
                <MasterUserList v-if="userType === 'master'" />
            </TabPane> -->
            <TabPane label="苗场" name="binfenSeedFarm">
                <BinFenSeedFarmUserList :departmentList="departmentList" v-if="userType === 'binfenSeedFarm'" />
            </TabPane>
            <!-- <TabPane label="苗场"
                name="externalSeedFarm">
                <ExternalSeedFarmUserList v-if="userType === 'externalSeedFarm'" />
            </TabPane> -->
            <TabPane label="转运站" name="station">
                <DistributionStationUserList v-if="userType === 'station'" />
            </TabPane>
            <TabPane label="客户经理" name="customerManager">
                <CustomerManagerUserList v-if="userType === 'customerManager'" />
            </TabPane>
			<TabPane label="客户代理" name="customerOutsideManager">
                <CustomerManagerOutsideUserList v-if="userType === 'customerOutsideManager'" />
            </TabPane>
            <!-- <TabPane label="仓管员"
                name="storeKeeper">
                <StorekeeperUserList v-if="userType === 'storeKeeper'" />
            </TabPane> -->
            <!-- <TabPane label="客服"
                name="customerService">
                <CustomerServiceUserList v-if="userType === 'customerService'" />
            </TabPane> -->
            <TabPane label="内部客户" name="binfenCustomer">
                <BinFenCustomerUserList v-if="userType === 'binfenCustomer'" />
            </TabPane>
            <TabPane label="外部客户" name="externalCustomer">
                <ExternalCustomerUserList v-if="userType === 'externalCustomer'" />
            </TabPane>
            <TabPane label="财务" name="finance">
                <FinanceUserList v-if="userType === 'finance'" />
            </TabPane>
                <TabPane label="人事" name="hr">
                <HrUserList v-if="userType === 'hr'" />
            </TabPane>
			<TabPane label="总监" name="inspector">
                <InspectorUserList :departmentList="departmentList" v-if="userType === 'inspector'" />
            </TabPane>
			<TabPane label="客户经理项目人" name="project">
                <ProjectManageList :departmentList="departmentList" v-if="userType === 'project'" />
            </TabPane>
        </Tabs>
    </Card>
</template>

<script>
import search from '@/libs/search';
import AdminUserList from './../../account-management/admin-user-management/admin-user-list';
import BinFenSeedFarmUserList from './../../account-management/binFenSeedFarm-user-management/binFenSeedFarm-user-list';
import DistributionStationUserList from './../../account-management/distributionStation-user-management/distributionStation-user-list';
import CustomerManagerUserList from './../../account-management/customerManager-user-management/customerManager-user-list';
import CustomerManagerOutsideUserList from './../../account-management/customerManager-user-management/customerManager-outside-user-list';
import BinFenCustomerUserList from './../../account-management/binFenCustomer-user-management/binFenCustomer-user-list';
import ExternalCustomerUserList from './../../account-management/externalCustomer-user-management/externalCustomer-user-list';
import FinanceUserList from './../../account-management/finance-user-management/finance-user-list';
import HrUserList from './../../account-management/hr-user-management/hr-user-list';
import InspectorUserList from './../../account-management/inspector-user-management/inspector-user-list';
import ProjectManageList from './../../account-management/project-manage-management/project-manage-list';
import { getDepartmentList } from '@/api/modules/system-management/department-management';
import { getCompanyList } from '@/api/modules/system-management/company-management';
export default {
    name: 'UserList',
    components: {
        AdminUserList,
        BinFenSeedFarmUserList,
        DistributionStationUserList,
        CustomerManagerUserList,
        CustomerManagerOutsideUserList,
        BinFenCustomerUserList,
        ExternalCustomerUserList,
        FinanceUserList,
        HrUserList,
        InspectorUserList,
        ProjectManageList
    },
    data() {
        return {
            userType: 'admin',
            departmentList: [],
            companyList: []
        };
    },
    mounted() {
        this.getDepartmentList();
        this.getCompanyList();
    },
    methods: {
        async getDepartmentList() {
            try {
                const tableSearch = search.getSearchParams();
                search.closeAllConditions(tableSearch);
                const res = await getDepartmentList(tableSearch);
                if (res.code === 0) {
                    this.departmentList = res.data.records;
                }
                else {
                    this.$Message.error(res.message || '部门列表查询失败');
                }
            }
            catch (error) {
                console.error('获取部门列表失败:', error);
                this.$Message.error('部门列表查询失败');
            }
        },
        async getCompanyList() {
            try {
                const tableSearch = search.getSearchParams();
                search.closeAllConditions(tableSearch);
                const res = await getCompanyList(tableSearch);
                if (res.code === 0) {
                    this.companyList = res.data.records;
                }
                else {
                    this.$Message.error(res.message || '公司列表查询失败');
                }
            }
            catch (error) {
                console.error('获取公司列表失败:', error);
                this.$Message.error('公司列表查询失败');
            }
        }
    }
};
</script>

<style scoped>
</style>
